import Button from "../../../../form/Button";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return <Button disabled={ !props.dirty || props.isLoading } color="default" className="pull-right" onClick={ props.saveForm }>
        Mentés
    </Button>
}